// extracted by mini-css-extract-plugin
export var button = "_ax-7";
export var buttonRow = "_ax-6";
export var fadeIn = "_ax-1";
export var gradient = "_ax-0";
export var panel = "_ax-2";
export var panelIn = "_ax-3";
export var subtitle = "_ax-5";
export var title = "_ax-4";